function levenshteinDistance(A, B) {
  // Create empty edit distance matrix for all possible modifications of
  // substrings of a to substrings of b.
  const a = A.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const b = B.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const distanceMatrix = Array(b.length + 1).fill(null).map(() => Array(a.length + 1).fill(null));

  // Fill the first row of the matrix.
  // If this is first row then we're transforming empty string to a.
  // In this case the number of transformations equals to size of a substring.
  for (let i = 0; i <= a.length; i += 1) {
    distanceMatrix[0][i] = i;
  }

  // Fill the first column of the matrix.
  // If this is first column then we're transforming empty string to b.
  // In this case the number of transformations equals to size of b substring.
  for (let j = 0; j <= b.length; j += 1) {
    distanceMatrix[j][0] = j;
  }

  for (let j = 1; j <= b.length; j += 1) {
    for (let i = 1; i <= a.length; i += 1) {
      const indicator = a[i - 1] === b[j - 1] ? 0 : 1;
      distanceMatrix[j][i] = Math.min(
        distanceMatrix[j][i - 1] + 1, // deletion
        distanceMatrix[j - 1][i] + 1, // insertion
        distanceMatrix[j - 1][i - 1] + indicator, // substitution
      );
    }
  }

  return distanceMatrix[b.length][a.length];
}

function termFreqMap(str) {
  const words = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').split(' ');
  const termFreq = {};
  words.forEach((w) => {
    termFreq[w] = (termFreq[w] || 0) + 1;
  });

  return termFreq;
}

function addKeysToDict(map, dict) {
  Object.keys(map).forEach((key) => {
    // eslint-disable-next-line no-param-reassign
    dict[key] = true;
  });
}

function termFreqMapToVector(map, dict) {
  const termFreqVector = [];
  Object.keys(dict).forEach((term) => {
    let val = 0;
    Object.keys(map).forEach((target) => {
      val += levenshteinDistance(term, target) < target.length * 0.20 ? map[target] : 0;
    });
    // termFreqVector.push(map[term] || 0);
    termFreqVector.push(val || 0);
  });
  return termFreqVector;
}

function vecDotProduct(vecA, vecB) {
  let product = 0;
  for (let i = 0; i < vecA.length; i += 1) {
    product += vecA[i] * vecB[i];
  }
  return product * 100;
}

function vecMagnitude(vec) {
  let sum = 0;
  for (let i = 0; i < vec.length; i += 1) {
    sum += vec[i] * vec[i];
  }
  return Math.sqrt(sum);
}

function cosineSimilarity(vecA, vecB) {
  return vecDotProduct(vecA, vecB) / (vecMagnitude(vecA) * vecMagnitude(vecB));
}

/**
 * @param {string} a
 * @param {string} b
 * @return {number}
 */
// eslint-disable-next-line import/prefer-default-export
export const Cosinesimilarity = (strA, strB) => {
  const termFreqA = termFreqMap(strA);
  const termFreqB = termFreqMap(strB);
  const dict = {};
  addKeysToDict(termFreqA, dict);
  addKeysToDict(termFreqB, dict);

  const termFreqVecA = termFreqMapToVector(termFreqA, dict);
  const termFreqVecB = termFreqMapToVector(termFreqB, dict);

  return cosineSimilarity(termFreqVecA, termFreqVecB);
};

/**
 * @param {string} a
 * @param {string} b
 * @return {number}
 */
export const LevenshteinDistance = (A, B) => levenshteinDistance(A, B);
